import {
  ActionIcon,
  Avatar,
  Divider,
  Loader,
  TypographyStylesProvider,
} from '@mantine/core'
import dayjs from 'dayjs'

import { navigate, routes, useParams } from '@redwoodjs/router'
import { Metadata, useQuery } from '@redwoodjs/web'

import DNButton from 'src/components/Buttons/Button/DNButton'
import AttachmentsRow from 'src/components/Notifications/Components/AttachmentsRow'
import { useEmailModalContext } from 'src/context/EmailModalContext'
import { GET_EMAIL_THREAD_BY_ID } from 'src/graphql/emails.graphql'
import IconLeftArrow from 'src/icons/IconLeftArrow'

//This component is currently formatted to show sent emails only
const EmailDetailsPage = () => {
  const { handleOpen: openEmailModal } = useEmailModalContext()

  const { id } = useParams()

  const { data, loading } = useQuery(GET_EMAIL_THREAD_BY_ID, {
    variables: {
      emailThreadId: id,
    },
  })

  const emailThread = data?.getEmailThreadById.emails[0]

  if (loading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader color="gray" size="sm" />
      </div>
    )
  }

  if (!emailThread) {
    return (
      <div className="flex h-full w-full items-center justify-center text-sm text-doubleNickel-gray-500">
        Email not found
      </div>
    )
  }

  return (
    <div className="flex h-full flex-col gap-2 px-4 pb-4">
      <Metadata title="EmailDetails" description="EmailDetails page" />
      <div className="flex flex-row items-center gap-1">
        <ActionIcon
          variant="subtle"
          color="gray"
          onClick={() => {
            navigate(routes.emails())
          }}
        >
          <IconLeftArrow className="h-4 w-4 fill-none stroke-doubleNickel-gray-700" />
        </ActionIcon>
        <Divider orientation="vertical" />
      </div>
      <Divider />
      <div className="flex h-full w-full flex-col gap-4 overflow-auto py-4">
        <div className="mb-2 flex w-full flex-row items-center justify-start gap-2  text-sm text-doubleNickel-gray-700">
          <Avatar color="blue">
            {emailThread.applicant.firstName.charAt(0)}
            {emailThread.applicant.lastName.charAt(0)}
          </Avatar>
          <div className="flex flex-col">
            <div className="flex flex-row items-baseline gap-2">
              <div className="text-base font-semibold">
                {emailThread.applicant.firstName}{' '}
                {emailThread.applicant.lastName}
              </div>
              <div className="text-xs">{emailThread.to.join(', ')}</div>
            </div>
            <div className="flex flex-row items-baseline gap-2">
              <div className="text-xs">
                from: {emailThread.employee.firstName}{' '}
                {emailThread.employee.lastName}
              </div>
              <div className="text-xs">{emailThread.from}</div>
            </div>
          </div>

          <div className="ml-auto text-xs text-doubleNickel-gray-500">
            {dayjs(emailThread.date).format('MM/DD/YYYY, h:mm A')}
          </div>
        </div>
        <div className="py-3 text-lg font-medium ">{emailThread.subject}</div>

        <TypographyStylesProvider className="">
          <div
            className="text-sm"
            dangerouslySetInnerHTML={{
              __html: emailThread.body,
            }}
          />
        </TypographyStylesProvider>
        {emailThread.attachments && emailThread.attachments.length > 0 && (
          <div className="mt-auto">
            <AttachmentsRow
              attachments={emailThread.attachments}
              applicantId={emailThread.applicant.applicantId}
            />
          </div>
        )}
      </div>

      <Divider className="mt-auto" />
      <div className="flex flex-row items-center gap-2">
        <DNButton
          onClick={() => {
            openEmailModal({
              applicantId: emailThread.applicant.applicantId,
              defaultTo: emailThread.to[0],
            })
          }}
        >
          Email {emailThread.applicant.firstName}{' '}
          {emailThread.applicant.lastName} again
        </DNButton>
      </div>
    </div>
  )
}

export default EmailDetailsPage
